export default {
  project: "Westfield",
  name: "Westfield",
  url: "http://thq-westfield.s3-website-ap-southeast-2.amazonaws.com",
  auth_landing_module: "/ordering",
  idle_limit: 180000,
  thor: {
    moduleCode: {
      development: "SWv2CTHE3H",
      production: "SWv2CTHE3H",
    },
    moduleCodeCorp: {
      production: "WSH2kdh2bcks",
      development: "WSH2kdh2bcks",
    },
    programId: null,
    products: {
      production: {
        cards: {
          red: 380172,
          ch: 725023,
          sb: 725021,
          rb: 725022,
        },
        trifolds: {
          red: 724988,
          none: 509370,
        },
      },
      development: {
        cards: {
          red: 380172,
          ch: 725023,
          sb: 725021,
          rb: 725022,
        },
        trifolds: {
          red: 724988,
          none: 509370,
        },
      },
    },
  },
  api: {
    westfield_auth_v1: {
      url: {
        development: "https://westfield.transactortech.co.nz/tx-auth/auth",
        production: "https://westfield.transactortech.co.nz/tx-auth/auth",
      },
    },
    westfield_v1: {
      url: {
        development:
          "https://westfield.transactortech.co.nz/Westfield-BulkOrder",
        production:
          "https://westfield.transactortech.co.nz/Westfield-BulkOrder",
      },
    },
    westfield_reporting_v1: {
      url: {
        development: "https://westfield.transactortech.co.nz",
        production: "https://westfield.transactortech.co.nz",
      },
    },
    tranxactor_westfield_corp: {
      url: {
        production:
          "https://westfield.transactortech.co.nz/Westfield-Corporate",
        development:
          "https://westfield.transactortech.co.nz/Westfield-Corporate",
      },
    },
  },
};
